﻿globalThis["needle:dependencies:ready"] = import("./register_types.ts")

export const needle_exported_files = new Array();
globalThis["needle:codegen_files"] = needle_exported_files;
needle_exported_files.push("assets/Virtually%20Sports%20Camel%20Racing.glb?v=1756202270132");
document.addEventListener("DOMContentLoaded", () =>
{
	const needleEngine = document.querySelector("needle-engine");
	if(needleEngine && needleEngine.getAttribute("src") === null)
	{
		needleEngine.setAttribute("hash", "1756202270132");
		needleEngine.setAttribute("src", JSON.stringify(needle_exported_files));
	}
});
